// styles
require("./PopupContent.css");

interface Props {
  header?: string;
  headerIcon?: any;
  headerIconAsMdbClassName?: any;
  children?: JSX.Element;
  additionalClassNames?: string;
  handleClose?: any;
  customClassForCardBody?: any;
}

const handleScroll = (event) => {
  event.stopPropagation();
}


const PopupContent = (props: Props) => {

  let className = props.customClassForCardBody ? `card-body ${props.customClassForCardBody}` : `card-body`;

  return (
    <div style={{ width: "100%", height: "100%" }} onScroll={handleScroll}>
      <div
        className="overlay"
        id="popupOverlay"
        style={{ display: "block" }}
      ></div>
      <div className='PopupContent center'>
        <div className={`card ${props.additionalClassNames}`}>
          {props.header && props.header.length && (
            <div className="card-header">
              {props.headerIconAsMdbClassName && (
                <i
                  style={{ marginRight: "10px" }}
                  className={props.headerIconAsMdbClassName}
                ></i>
              )}
              {props.headerIcon && (
                <img style={{ marginRight: "10px" }} src={props.headerIcon} />
              )}
              {props.header}
              {props.handleClose && (
                <button
                  onClick={props.handleClose}
                  style={{ position: "fixed", right: "30px" }}
                  type="button"
                  className="btn-close"
                  data-mdb-dismiss="modal"
                  aria-label="Close"
                ></button>
              )}
            </div>
          )}
          <div className={className}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default PopupContent;
